export class ShippingAddressModel {
    id = 0;
    firstName = '';
    lastName = '';
    company = '';
    address1 = '';
    address2 = '';
    city = '';
    state = '';
    zipCode = '';
    phone = '';
    choosen = false;
    addrType = 0;
    status = 1;
    fNameError = false;
    lNameError = false;
    addressError = false;
    phoneError = false;
    zipError = false;
    cityError = false;
    stateError = false;
}
export function toAddrModel(p) {
    if (!p || !p.Address1)
        return {};
    const addr = new ShippingAddressModel();
    addr.id = p.SysNo;
    addr.firstName = p.FirstName;
    addr.lastName = p.LastName;
    addr.company = p.Company;
    addr.address1 = p.Address1;
    addr.address2 = p.Address2;
    addr.phone = p.Phone;
    addr.zipCode = p.Zip;
    addr.city = p.City;
    addr.state = p.State;
    addr.addrType = p.ResidenceType;
    addr.status = p.CustomerAddressStatus;
    return addr;
}
export function toAddrParams(addr) {
    if (!addr || !addr.address1)
        return {};
    return {
        SysNo: addr.id,
        FirstName: addr.firstName,
        LastName: addr.lastName,
        Company: addr.company,
        Address1: addr.address1,
        Address2: addr.address2,
        City: addr.city,
        State: addr.state,
        Zip: addr.zipCode,
        Phone: addr.phone,
        ResidenceType: addr.addrType,
        CustomerAddressStatus: addr.status
    };
}
export var ResidenceTypes;
(function (ResidenceTypes) {
    ResidenceTypes[ResidenceTypes["Unknown"] = 0] = "Unknown";
    ResidenceTypes[ResidenceTypes["Residential"] = 1] = "Residential";
    ResidenceTypes[ResidenceTypes["Commercial"] = 2] = "Commercial";
})(ResidenceTypes || (ResidenceTypes = {}));
export class AddressBookModel {
    id = 0;
    firstName = '';
    lastName = '';
    company = '';
    address1 = '';
    address2 = '';
    city = '';
    state = '';
    zipCode = '';
    phone = '';
    addrType = 0;
    fNameError = false;
    lNameError = false;
    addressError = false;
    phoneError = false;
    zipError = false;
    cityError = false;
    stateError = false;
}
